module.exports = __webpack_public_path__ + "img/logo_podo_col_whtie.5b4db7b8.png";